import { RouterModule } from '@angular/router';
import { ParamMap } from '@angular/router';
import { Router } from '@angular/router';
import { Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ArchitecturePage } from '../../../../../../../website/pages/ArchitecturePage/ArchitecturePage';
import { CapabilitiesPage } from '../../../../../../../website/pages/CapabilitiesPage/CapabilitiesPage';
import { GettingStartedPage } from '../../../../../../../website/pages/GettingStartedPage/GettingStartedPage';
import { GitHubPage } from '../../../../../../../website/pages/GitHubPage/GitHubPage';
import { HomePage } from '../../../../../../../website/pages/HomePage/HomePage';
import { PluginsPage } from '../../../../../../../website/pages/PluginsPage/PluginsPage';
import { RealTimePage } from '../../../../../../../website/pages/RealTimePage/RealTimePage';
import { AboutAsidePage } from '../../../../../../../website/pages/about/AboutAsidePage/AboutAsidePage';
import { AboutPage } from '../../../../../../../website/pages/about/AboutPage/AboutPage';
import { BuildPipelinePage } from '../../../../../../../website/pages/architecture/BuildPipelinePage/BuildPipelinePage';
import { DataFlowPage } from '../../../../../../../website/pages/architecture/DataFlowPage/DataFlowPage';
import { ModuleGraphPage } from '../../../../../../../website/pages/architecture/ModuleGraphPage/ModuleGraphPage';
import { RuntimePage } from '../../../../../../../website/pages/architecture/RuntimePage/RuntimePage';
import { StackDiagramPage } from '../../../../../../../website/pages/architecture/StackDiagramPage/StackDiagramPage';
import { AngularGenerationPage } from '../../../../../../../website/pages/capabilities/AngularGenerationPage/AngularGenerationPage';
import { EventSystemPage } from '../../../../../../../website/pages/capabilities/EventSystemPage/EventSystemPage';
import { PluginModelPage } from '../../../../../../../website/pages/capabilities/PluginModelPage/PluginModelPage';
import { RealTimeMessagingPage } from '../../../../../../../website/pages/capabilities/RealTimeMessagingPage/RealTimeMessagingPage';
import { RenderingPage } from '../../../../../../../website/pages/capabilities/RenderingPage/RenderingPage';
import { SpiExtensibilityPage } from '../../../../../../../website/pages/capabilities/SpiExtensibilityPage/SpiExtensibilityPage';
import { ApplicationPage } from '../../../../../../../website/pages/gettingstarted/ApplicationPage/ApplicationPage';
import { BootstrapPage } from '../../../../../../../website/pages/gettingstarted/BootstrapPage/BootstrapPage';
import { BuildAndRunPage } from '../../../../../../../website/pages/gettingstarted/BuildAndRunPage/BuildAndRunPage';
import { FirstComponentPage } from '../../../../../../../website/pages/gettingstarted/FirstComponentPage/FirstComponentPage';
import { GettingStartedAsidePage } from '../../../../../../../website/pages/gettingstarted/GettingStartedAsidePage/GettingStartedAsidePage';
import { NextStepsPage } from '../../../../../../../website/pages/gettingstarted/NextStepsPage/NextStepsPage';
import { WhatsHappeningPage } from '../../../../../../../website/pages/gettingstarted/WhatsHappeningPage/WhatsHappeningPage';
import { HomeAsidePage } from '../../../../../../../website/pages/home/HomeAsidePage/HomeAsidePage';
import { SalesDashboard } from '../../../../../../../website/pages/home/SalesDashboard/SalesDashboard';
import { AgChartsEnterprisePluginPage } from '../../../../../../../website/pages/plugins/AgChartsEnterprisePluginPage/AgChartsEnterprisePluginPage';
import { AgChartsPluginPage } from '../../../../../../../website/pages/plugins/AgChartsPluginPage/AgChartsPluginPage';
import { AgGridEnterprisePluginPage } from '../../../../../../../website/pages/plugins/AgGridEnterprisePluginPage/AgGridEnterprisePluginPage';
import { AgGridPluginPage } from '../../../../../../../website/pages/plugins/AgGridPluginPage/AgGridPluginPage';
import { AngularMavenPluginPage } from '../../../../../../../website/pages/plugins/AngularMavenPluginPage/AngularMavenPluginPage';
import { AngularPluginPage } from '../../../../../../../website/pages/plugins/AngularPluginPage/AngularPluginPage';
import { ChartJsPluginPage } from '../../../../../../../website/pages/plugins/ChartJsPluginPage/ChartJsPluginPage';
import { ClientPluginPage } from '../../../../../../../website/pages/plugins/ClientPluginPage/ClientPluginPage';
import { CorePluginPage } from '../../../../../../../website/pages/plugins/CorePluginPage/CorePluginPage';
import { EasingPluginPage } from '../../../../../../../website/pages/plugins/EasingPluginPage/EasingPluginPage';
import { FontAwesomePluginPage } from '../../../../../../../website/pages/plugins/FontAwesomePluginPage/FontAwesomePluginPage';
import { FontAwesomeProPluginPage } from '../../../../../../../website/pages/plugins/FontAwesomeProPluginPage/FontAwesomeProPluginPage';
import { FullCalendarPluginPage } from '../../../../../../../website/pages/plugins/FullCalendarPluginPage/FullCalendarPluginPage';
import { FullCalendarProPluginPage } from '../../../../../../../website/pages/plugins/FullCalendarProPluginPage/FullCalendarProPluginPage';
import { RabbitMQPluginPage } from '../../../../../../../website/pages/plugins/RabbitMQPluginPage/RabbitMQPluginPage';
import { TypeScriptClientPluginPage } from '../../../../../../../website/pages/plugins/TypeScriptClientPluginPage/TypeScriptClientPluginPage';
import { VertxPluginPage } from '../../../../../../../website/pages/plugins/VertxPluginPage/VertxPluginPage';
import { WebAwesomePluginPage } from '../../../../../../../website/pages/plugins/WebAwesomePluginPage/WebAwesomePluginPage';
import { WebAwesomeProPluginPage } from '../../../../../../../website/pages/plugins/WebAwesomeProPluginPage/WebAwesomeProPluginPage';
import { ChoosingPatternPage } from '../../../../../../../website/pages/realtime/ChoosingPatternPage/ChoosingPatternPage';
import { CommunicationLayersPage } from '../../../../../../../website/pages/realtime/CommunicationLayersPage/CommunicationLayersPage';
import { DataServicesPage } from '../../../../../../../website/pages/realtime/DataServicesPage/DataServicesPage';
import { RabbitMQCodeSamplesPage } from '../../../../../../../website/pages/realtime/RabbitMQCodeSamplesPage/RabbitMQCodeSamplesPage';
import { RabbitMQPage } from '../../../../../../../website/pages/realtime/RabbitMQPage/RabbitMQPage';
import { RestAndAjaxPage } from '../../../../../../../website/pages/realtime/RestAndAjaxPage/RestAndAjaxPage';
import { UseCasesPage } from '../../../../../../../website/pages/realtime/UseCasesPage/UseCasesPage';
import { VertxCodeSamplesPage } from '../../../../../../../website/pages/realtime/VertxCodeSamplesPage/VertxCodeSamplesPage';
import { VertxEventBusPage } from '../../../../../../../website/pages/realtime/VertxEventBusPage/VertxEventBusPage';
export const routes: Routes = [ {
  "path" : "",
  "redirectTo" : "home",
  "pathMatch" : "full"
}, {
  "path" : "architecture",
  "component" : ArchitecturePage
}, {
  "path" : "capabilities",
  "component" : CapabilitiesPage
}, {
  "path" : "getting-started",
  "component" : GettingStartedPage
}, {
  "path" : "github",
  "component" : GitHubPage
}, {
  "path" : "home",
  "component" : HomePage
}, {
  "path" : "plugins",
  "component" : PluginsPage
}, {
  "path" : "real-time",
  "component" : RealTimePage
}, {
  "path" : "about",
  "outlet" : "aside",
  "component" : AboutAsidePage
}, {
  "path" : "about",
  "component" : AboutPage
}, {
  "path" : "architecture/build-pipeline",
  "component" : BuildPipelinePage
}, {
  "path" : "architecture/data-flow",
  "component" : DataFlowPage
}, {
  "path" : "architecture/module-graph",
  "component" : ModuleGraphPage
}, {
  "path" : "architecture/runtime",
  "component" : RuntimePage
}, {
  "path" : "architecture/stack",
  "component" : StackDiagramPage
}, {
  "path" : "capabilities/angular-generation",
  "component" : AngularGenerationPage
}, {
  "path" : "capabilities/event-system",
  "component" : EventSystemPage
}, {
  "path" : "capabilities/plugin-model",
  "component" : PluginModelPage
}, {
  "path" : "capabilities/real-time-messaging",
  "component" : RealTimeMessagingPage
}, {
  "path" : "capabilities/rendering",
  "component" : RenderingPage
}, {
  "path" : "capabilities/spi-extensibility",
  "component" : SpiExtensibilityPage
}, {
  "path" : "getting-started/application",
  "component" : ApplicationPage
}, {
  "path" : "getting-started/bootstrap",
  "component" : BootstrapPage
}, {
  "path" : "getting-started/build-and-run",
  "component" : BuildAndRunPage
}, {
  "path" : "getting-started/first-component",
  "component" : FirstComponentPage
}, {
  "path" : "getting-started",
  "outlet" : "aside",
  "component" : GettingStartedAsidePage
}, {
  "path" : "getting-started/next-steps",
  "component" : NextStepsPage
}, {
  "path" : "getting-started/whats-happening",
  "component" : WhatsHappeningPage
}, {
  "path" : "home",
  "outlet" : "aside",
  "component" : HomeAsidePage
}, {
  "path" : "dashboard",
  "component" : SalesDashboard
}, {
  "path" : "plugins/agcharts-enterprise",
  "component" : AgChartsEnterprisePluginPage
}, {
  "path" : "plugins/agcharts",
  "component" : AgChartsPluginPage
}, {
  "path" : "plugins/aggrid-enterprise",
  "component" : AgGridEnterprisePluginPage
}, {
  "path" : "plugins/aggrid",
  "component" : AgGridPluginPage
}, {
  "path" : "plugins/angular-maven-plugin",
  "component" : AngularMavenPluginPage
}, {
  "path" : "plugins/angular",
  "component" : AngularPluginPage
}, {
  "path" : "plugins/chartjs",
  "component" : ChartJsPluginPage
}, {
  "path" : "plugins/client",
  "component" : ClientPluginPage
}, {
  "path" : "plugins/core",
  "component" : CorePluginPage
}, {
  "path" : "plugins/easing",
  "component" : EasingPluginPage
}, {
  "path" : "plugins/fontawesome",
  "component" : FontAwesomePluginPage
}, {
  "path" : "plugins/fontawesome-pro",
  "component" : FontAwesomeProPluginPage
}, {
  "path" : "plugins/fullcalendar",
  "component" : FullCalendarPluginPage
}, {
  "path" : "plugins/fullcalendar-pro",
  "component" : FullCalendarProPluginPage
}, {
  "path" : "plugins/rabbitmq",
  "component" : RabbitMQPluginPage
}, {
  "path" : "plugins/typescript-client",
  "component" : TypeScriptClientPluginPage
}, {
  "path" : "plugins/vertx",
  "component" : VertxPluginPage
}, {
  "path" : "plugins/web-awesome",
  "component" : WebAwesomePluginPage
}, {
  "path" : "plugins/web-awesome-pro",
  "component" : WebAwesomeProPluginPage
}, {
  "path" : "real-time/choosing-a-pattern",
  "component" : ChoosingPatternPage
}, {
  "path" : "real-time/communication-layers",
  "component" : CommunicationLayersPage
}, {
  "path" : "real-time/data-services",
  "component" : DataServicesPage
}, {
  "path" : "real-time/rabbitmq-code-samples",
  "component" : RabbitMQCodeSamplesPage
}, {
  "path" : "real-time/rabbitmq",
  "component" : RabbitMQPage
}, {
  "path" : "real-time/rest-and-ajax",
  "component" : RestAndAjaxPage
}, {
  "path" : "real-time/use-cases",
  "component" : UseCasesPage
}, {
  "path" : "real-time/vertx-code-samples",
  "component" : VertxCodeSamplesPage
}, {
  "path" : "real-time/vertx-event-bus",
  "component" : VertxEventBusPage
} ];
@NgModule({
	imports:[RouterModule.forRoot(routes)
],
	declarations:[],
	providers: [],
	exports:[RouterModule
],
	bootstrap:[],
	schemas:[]
})
export class AngularRoutingModule
{

}
